import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
import noodle from 'noodle';

export default component((node, ctx) => {

  //console.log("product mounted")
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
  const form = node.querySelector('form')
  
  const { selectedOrFirstAvailableVariant, product } = json
  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  //console.log("product: " + JSON.stringify(json, null, "\t"))
  //console.log("current variant: "+ JSON.stringify(currentVariant, null, "\t"))

  
  form.addEventListener('submit', e => {
    e.preventDefault()
    currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]
    addVariant(currentVariant, form.elements.quantity.value, form.elements.add, product.id)
  })
  /*
  const disableSoldOut = () => {
    //console.log(form.elements)

    product.variants.forEach(v => {
      if (v.checked) state.options[index] = r.value
    })
  }
  
  disableSoldOut()
  */

  const sliderWrap = node.querySelector('[data-slider]')
  
  if(sliderWrap){
    const sliderNext = node.querySelector('[data-slider-next]')
    const sliderPrev = node.querySelector('[data-slider-prev]')
    const sliderIndexCount = node.querySelector('[data-slider-index-count]')
    const slideCount = sliderWrap.dataset.slideCount;
    const slider = noodle(sliderWrap, {
      setHeight: false,
      a11y: false,
    })

    const onSliderNext = () => {
      if(slider.index == slideCount){
        slider.select(0);
      }else{
        slider.next();
      }
    }

    const onSliderPrev = () => {
      slider.prev();
    }

    const onSliderIndex = (index) => {
      let end = parseFloat(index)+1;
      let start = parseFloat(sliderIndexCount.dataset.sliderIndexCount);

      
      let range = end - start;
      let current = start;
      let increment = end > start? 1 : -1;
      
      sliderIndexCount.dataset.sliderIndexCount = end;
      
      if(start === end ){
        return;
      }
      let timer = setInterval(function() {
          current += increment;
          if(current < 10){
            sliderIndexCount.innerHTML = '0' + current;
          }else{
            sliderIndexCount.innerHTML = current;
          }
          //sliderIndexCount.innerHTML = current;
          if (current == end) {
              clearInterval(timer);
          }
      }, 100);
    }

    sliderNext.addEventListener('click', onSliderNext)
    sliderPrev.addEventListener('click', onSliderPrev)

    slider.on('select', index => {
      //console.log("swipe to " + index);
      onSliderIndex(index);
    })
  }
  

})
